// SPDX-License-Identifier: AGPL-3.0-or-later

// AFK controls push eligibility separately from the user's visible presence status.
export function isAwayForPushNotifications({
	isMobile,
	isBackground,
	inactiveDurationMs,
	timeoutSeconds,
}: {
	isMobile: boolean;
	isBackground: boolean;
	inactiveDurationMs: number;
	timeoutSeconds: number;
}): boolean {
	if (isMobile) return isBackground;
	if (timeoutSeconds === 0) return true;
	return inactiveDurationMs >= timeoutSeconds * 1000;
}
